import React, { useState, useEffect, useRef } from "react";
import "./index.css";

const Ciallo = ({ dur = 20, color = 'red', size = "15px", delay = "0s" }) => {
    const [responsiveSize, setResponsiveSize] = useState(size);
    const [contentWidth, setContentWidth] = useState(0);
    const contentRef = useRef(null);

    useEffect(() => {
        const updateSize = () => {
            const width = window.innerWidth;
            let newSize = size;
            
            // 根据屏幕宽度调整字体大小
            if (width <= 320) {
                newSize = size.replace(/\d+px/, Math.max(parseInt(size) * 0.6, 10) + 'px');
            } else if (width <= 480) {
                newSize = size.replace(/\d+px/, Math.max(parseInt(size) * 0.7, 12) + 'px');
            } else if (width <= 768) {
                newSize = size.replace(/\d+px/, Math.max(parseInt(size) * 0.8, 14) + 'px');
            }
            
            setResponsiveSize(newSize);
        };

        updateSize();
        window.addEventListener('resize', updateSize);
        
        return () => {
            window.removeEventListener('resize', updateSize);
        };
    }, [size]);

    useEffect(() => {
        // 动态获取内容宽度
        if (contentRef.current) {
            setContentWidth(contentRef.current.offsetWidth);
        }
    }, [responsiveSize]);

    // 动画时长可根据内容宽度自适应
    const duration = dur * (contentWidth ? (window.innerWidth + contentWidth) / 400 : 1); // 400为基准距离

    return (
        <div className="ciallo-fade-wrapper">
            <div
                className="ciallo-fade"
                style={{
                    color: color,
                    fontSize: responsiveSize,
                    animationDuration: `${duration}s`,
                    animationDelay: delay,
                    '--move-distance': contentWidth ? `${window.innerWidth + contentWidth}px` : '100vw',
                }}
            >
                <span ref={contentRef}>Ciallo～(∠・ω&lt; )⌒★</span>
            </div>
        </div>
    );
}

export default Ciallo;
